import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'

import { callApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { upsertForm } from '../../../reducers/form'

const mapStateToProps = (state) => {
    return {
        templates: state.templates
    }
}

const CreateInstallation = ({ dispatch, navigate, templates }) => {
    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('templates', 'LIST')))
    }, [dispatch])

    const submitFX = (formData, formId) => {
        // Validate VIN - only letters and numbers allowed
        const vinRegex = /^[a-zA-Z0-9]+$/
        if (!vinRegex.test(formData.vin)) {
            dispatch(upsertForm({ id: formId, status: 'ERROR', body: 'VIN must contain only letters and numbers (no spaces or special characters)' }))
            return
        }
        formData.vin = formData.vin.toUpperCase()
        dispatch(callApi(apiResourceEndpoint('installations', 'CREATE'), formData, formId))
    }

    const successFX = (installationId) => {
        navigate(buildRoutePath(routes.appInstallationView.path, { installId: installationId }))
    }

    const templateOptions = templates.map(template => ({ label: template.name, value: template.id }))

    return (
        <div className="app-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Create a New Installation</h1>
                        <p>
                            To create an installation, please take a picture of the VIN or enter in the field below.
                        </p>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    <div className="content-box editable">
                        <SHSForm
                            submitFX={submitFX}
                            successFX={successFX}
                            showCancel={true}
                            cancelAction={() => navigate(buildRoutePath(routes.appIndex.path))}
                            buttonLabel="Start Installation">
                            <InputElement
                                type="text"
                                id="vin"
                                label="VIN"
                                placeholder="i.e. 1X1X11ABCD12345"
                                required />
                            <InputElement
                                type="valueSelect"
                                id="templateId"
                                label="Template"
                                options={templateOptions}
                                required />
                        </SHSForm>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect(mapStateToProps)(CreateInstallation))
